import { render, staticRenderFns } from "./PackageKidsApprovedRapid.vue?vue&type=template&id=b0a1c9ec&scoped=true"
import script from "./PackageKidsApprovedRapid.vue?vue&type=script&lang=js"
export * from "./PackageKidsApprovedRapid.vue?vue&type=script&lang=js"
import style0 from "./PackageKidsApprovedRapid.vue?vue&type=style&index=0&id=b0a1c9ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a1c9ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0a1c9ec')) {
      api.createRecord('b0a1c9ec', component.options)
    } else {
      api.reload('b0a1c9ec', component.options)
    }
    module.hot.accept("./PackageKidsApprovedRapid.vue?vue&type=template&id=b0a1c9ec&scoped=true", function () {
      api.rerender('b0a1c9ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Package/PackageKidsApprovedRapid.vue"
export default component.exports